import DSGStore from "../DSGStore";
import PreviewImage from "../components/PreviewImage";

const SwissReferences = () => {
	const swissReferences = [
		{
			title: "Portfolioverkauf im Share Deal",
			clickable: true,
			previewImage: "/assets/swiss_references/0/1.jpeg",
			previewImageAlt: "Portfolioverkauf im Share Deal",
			images: [
				"/assets/swiss_references/0/1.jpeg",
				"/assets/swiss_references/0/2.jpeg",
			],
			points: [
				"Objektart: Portfolio",
				"Transaktionsvolumen: zweistelliger Millionenbetrag",
				"Tätigkeit: Transaktionsbegleitung",
			],
			additionalText: (
				<>
					Bei dem Vorhaben handelt es sich um einen Portfolioverkauf
					im Share Deal mit einem zweistelligen Millionenbetrag in der
					Schweiz.
					<br />
					<br />
					Dank unserer umfassenden Transaktionsbegleitung konnte das
					Portfolio reibungslos und zielgerichtet an ein
					Zentralschweizer Family Office veräussert werden. Der
					strukturierte Prozess und die enge Abstimmung mit allen
					Beteiligten führten zu einem zügigen und erfolgreichen
					Abschluss.
				</>
			),
		},
	];

	const handleOpen = (index: number) => {
		const clickedReference = swissReferences[index];

		DSGStore.update((state) => {
			state.referenceModalOpen = true;
			state.referenceModalTitle = clickedReference.title;
			state.referenceModalImages = clickedReference.images;
			state.referenceModalPoints = clickedReference.points;
			state.referenceModalAdditionalText =
				clickedReference.additionalText;
		});
	};

	return (
		<div
			className="flex min-h-screen w-full flex-col py-12 md:pt-16 md:pb-32"
			id="swiss-reference"
			style={{
				backgroundImage: `url("/assets/references_background.jpg")`,
				objectFit: "cover",
				backgroundSize: "cover",
			}}
		>
			<h1 className="mb-6 text-center text-4xl text-ds-yellow md:text-5xl">
				Jüngste Schweizer Referenzen
			</h1>
			<div className="mt-8 grid flex-1 grid-cols-1 gap-2 md:gap-0 lg:grid-cols-3">
				<div></div>
				{swissReferences.map((reference, index) => (
					<PreviewImage
						key={index}
						clickHandler={() => {
							if (reference.clickable) handleOpen(index);
						}}
						title={reference.title}
						url={reference.previewImage}
						alt={reference.previewImageAlt}
					/>
				))}
				<div></div>
			</div>
		</div>
	);
};

export default SwissReferences;
